import React from 'react';

const DataTable = ({ 
    data = [], 
    columns = [], 
    maxHeight = null,
    showScrollbar = false,
    emptyStateMessage ,
    emptyStateSubMessage 
}) => {
    return (
        <div className="overflow-x-auto bg-white">
            <div 
                className={showScrollbar ? 'overflow-y-auto border border-gray-200 rounded-lg' : ''}
                style={showScrollbar ? { 
                    height: maxHeight || '250px',
                    overflowY: 'scroll',
                    scrollbarWidth: 'auto'
                } : {}}
            >
                <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-sm">
                    <thead className="bg-gray-50">
                        <tr>
                            {columns.map((column, index) => (
                                <th 
                                    key={index}
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b"
                                >
                                    {column.header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data && data?.length > 0 ? (
                            data?.map((item, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    {columns.map((column, colIndex) => (
                                        <td 
                                            key={colIndex}
                                            className={`px-6 py-4 text-sm text-gray-900 ${
                                                column.maxWidth ? 'max-w-xs' : 'whitespace-nowrap'
                                            }`}
                                        >
                                            {column.render ? column.render(item) : item[column.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td 
                                    colSpan={columns.length} 
                                    className="px-6 py-12 text-center text-gray-500"
                                >
                                    <div className="flex flex-col items-center">
                                        <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <p className="text-lg font-medium text-gray-900 mb-2">{emptyStateMessage || t("No_data")}</p>
                                        <p className="text-sm text-gray-500">{emptyStateSubMessage||t("refreshtoload")}</p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DataTable;
